/**
 * @Description 益禾堂预估销售额-营业额预估结论值
 * 新版
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132274569
 * 25年8月版
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=149533541
 */

import { FC } from 'react';
import { Col } from 'antd';
import {
  estimateSalesReasonableSelectYHT,
} from '@/common/components/business/DynamicComponent/config';
import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';


const EstimateSalesConclusionYHTDetail: FC<any> = ({
  textValue
}) => {
  const methods = useMethods({
    getShowVal: (target: any, val: string) => {
      const { options } = target || {};
      if (isArray(options) && options.length) {
        const targetOption = options.find((item) => item.value === target[val]);
        return targetOption?.detailShowVal || '-';
      }
      return '-';
    }
  });
  return (
    <Col span={12}>
      <V2DetailItem
        label={estimateSalesReasonableSelectYHT.label}
        value={methods.getShowVal(textValue, estimateSalesReasonableSelectYHT.keyValue)}
      />
    </Col>
  );
};

export default EstimateSalesConclusionYHTDetail;
